import md5 from 'md5'

const SIGN_KEY = process.env.VUE_APP_SIGN_KEY || 'your-sign-secret-key'

/**
 * 生成签名
 * 规则：
 * 1. 过滤掉 sign 字段和空值
 * 2. 按 key 字母升序排序
 * 3. 拼接为 key1=value1&key2=value2&...
 * 4. 末尾追加 &key=密钥
 * 5. 对整个字符串做 MD5
 */
export function generateSign(params, key = SIGN_KEY) {
  const filtered = {}
  Object.keys(params).forEach(k => {
    if (k.toLowerCase() !== 'sign' && params[k] !== undefined && params[k] !== null && params[k] !== '') {
      filtered[k] = params[k]
    }
  })

  const sortedKeys = Object.keys(filtered).sort()
  const paramStr = sortedKeys.map(k => {
    let v = filtered[k]
    if (typeof v === 'object') {
      v = JSON.stringify(v)
    }
    return `${k}=${v}`
  }).join('&')

  const signStr = paramStr + '&key=' + key
  return md5(signStr)
}

export default { generateSign }
